import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import Program from './Program/Program';
import EntryDetail from './EntryDetail/EntryDetail';
import * as api from '../../api';
import * as utils from '../../utils';
import { ROUTING } from '../../constants';

class App extends Component {
  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    api.initHash();
  }

  componentDidUpdate(prevProps) {
    // try track route change event
    if (this.props.location !== prevProps.location) {
      utils.statsEvent('section', this.props.location.pathname);
    }
  }

  // -------------------------------------------------------
  // Entry Detail
  // -------------------------------------------------------

  render() {
    return (
      <div>
        <Route path="/" component={Program} />
        <Route
          path={`${ROUTING.DETAIL}/:entryId/:timeId`}
          component={EntryDetail}
        />
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js